import { render, staticRenderFns } from "./HelpBanner.vue?vue&type=template&id=06c2f01c&scoped=true"
import script from "./HelpBanner.vue?vue&type=script&lang=js"
export * from "./HelpBanner.vue?vue&type=script&lang=js"
import style0 from "./HelpBanner.vue?vue&type=style&index=0&id=06c2f01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2f01c",
  null
  
)

export default component.exports